import pDefer, { DeferredPromise } from "p-defer"
import { apiClient } from "infra/api-client"
import { BASE_URL } from "global"
import { LllNode } from "modules/lll/lll-nodes"


class LllLookupService {

  private static cache_expiry = 10 * 60 * 1000;

  private defer!: DeferredPromise<LllNode>
  private nodes: Record<string, LllNode> = {};
  private baseUrl!: string;

  constructor() {
    // @ts-ignore
  }

  private flatten(rootNode: LllNode) {
    const result: Record<string, LllNode> = {};

    function addNode(node: LllNode) {
      result[node.fqn] = node;
      node.getChildren()?.forEach(child => {
        addNode(child);
      })
    }
    addNode(rootNode);
    this.nodes = result;
  }

  getBaseUrl(){
    return this.baseUrl;
  }

  get flatNodes() {
    return this.nodes;
  }

  private filterTree(node: LllNode): LllNode {

    const toRemove: number[] = [];

    const children =  node.getChildren() ?? []
    children.forEach((item, index) => {
      if(item.hide) {
        toRemove.push(index);
      }
    });
    toRemove.reverse().forEach(i => children.splice(i, 1));

    for (const child of node.getChildren() ?? []) {
      this.filterTree(child);
    }

    return node;
  }

  private async fetchActivityTree() {

    const response = await apiClient.get<{
      baseUrl: string;
      activityTree: Record<string, any>;
    }>(BASE_URL + "lll/getActivityTree", {});

    try {
      this.baseUrl = response.data.baseUrl;

      let root = LllNode.createNode(response.data.activityTree);
      root = this.filterTree(root);

      if(this.defer) {
        this.defer.resolve(root)
      }
      this.flatten(root)
      setTimeout(() => {
        this.defer = null!
      }, LllLookupService.cache_expiry)
    } catch (error) {
      if (this.defer) {
        this.defer.reject(error);
        this.defer = null!;
      }
    }
  }

  getActivityTree(): Promise<LllNode> {
    if (!this.defer) {
      this.defer = pDefer();
      this.fetchActivityTree();
    }

    return this.defer.promise
  }

  findNodeByFqn(fqn: string){
    return this.flatNodes[fqn];
  }

}

export const lllLookupService = new LllLookupService();